import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Switch,
  Box,
  RadioGroup,
  Radio,
  Typography,
} from "@mui/material";
import useUserFilters from "../../hooks/useUserFilters";

const KellyModal = ({ open, onClose, onSave, kellySettings }) => {
  const [bankroll, setBankroll] = useState("");
  const [roundStakes, setRoundStakes] = useState(false);
  const [roundTo, setRoundTo] = useState("10");
  const { saveFilter } = useUserFilters();

  useEffect(() => {
    if (kellySettings) {
      setBankroll(kellySettings.bankroll || "");
      setRoundStakes(kellySettings.roundStakes || false);
      setRoundTo(kellySettings.roundTo || "10");
    }
  }, [kellySettings]);

  const handleSave = () => {
    const newKellySettings = {
      bankroll: parseFloat(bankroll),
      roundStakes,
      roundTo,
    };
    saveFilter({
      key: "kellySettings",
      content: newKellySettings,
      category: "value-betting",
    });
    onSave(newKellySettings);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Kelly Stake Settings</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          <TextField
            label="Bankroll"
            type="number"
            value={bankroll}
            onChange={(e) => setBankroll(e.target.value)}
            fullWidth
          />
          <FormControlLabel
            control={
              <Switch
                checked={roundStakes}
                onChange={(e) => setRoundStakes(e.target.checked)}
              />
            }
            label="Round Stakes"
          />
          {roundStakes && (
            <Box>
              <Typography variant="subtitle2">Round to:</Typography>
              <RadioGroup
                row
                value={roundTo}
                onChange={(e) => setRoundTo(e.target.value)}
              >
                <FormControlLabel
                  value="5"
                  control={<Radio />}
                  label="Nearest 5"
                />
                <FormControlLabel
                  value="10"
                  control={<Radio />}
                  label="Nearest 10"
                />
              </RadioGroup>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KellyModal;
